export const GPS_CUSTOM_FILTERS = {
  PARTIAL: 'partial',
  REQUEST_COMPLIANT: 'request_compliant',
  REQUEST_NON_COMPLIANT: 'request_non_compliant',
  INTERVENTION_COMPLIANT: 'intervention_compliant',
  INTERVENTION_NON_COMPLIANT: 'intervention_non_compliant',
  OUT_OF_DATE: 'out_of_date'
};
